export default __webpack_public_path__ + "static/media/donut-overview.682eebd4.png";